/**
 * The player's options, kept in this browser (localStorage): volumes (all, music, effects) and mute, the team name.
 * If the storage is unavailable (private window), the defaults apply.
 */
export interface Options {
  /** 0 to 1: everything, then the music and the sound effects. */
  volume: number;
  music: number;
  effects: number;
  muted: boolean;
  /** Filled in the lobby and as the first local team. */
  teamName: string;
}

const KEY = 'invaders.options';
const DEFAULTS: Options = { volume: 0.8, music: 0.5, effects: 0.8, muted: false, teamName: '' };
let cache: Options | null = null;

export function loadOptions(): Options {
  if (cache) return cache;
  let stored: Partial<Options> = {};
  try { stored = JSON.parse(localStorage.getItem(KEY) ?? '{}') as Partial<Options>; } catch { /* defaults */ }
  cache = {
    volume: typeof stored.volume === 'number' ? Math.min(1, Math.max(0, stored.volume)) : DEFAULTS.volume,
    music: typeof stored.music === 'number' ? Math.min(1, Math.max(0, stored.music)) : DEFAULTS.music,
    effects: typeof stored.effects === 'number' ? Math.min(1, Math.max(0, stored.effects)) : DEFAULTS.effects,
    muted: typeof stored.muted === 'boolean' ? stored.muted : DEFAULTS.muted,
    teamName: typeof stored.teamName === 'string' ? stored.teamName.slice(0, 16) : DEFAULTS.teamName,
  };
  return cache;
}

export function saveOptions(patch: Partial<Options>): Options {
  cache = { ...loadOptions(), ...patch };
  try { localStorage.setItem(KEY, JSON.stringify(cache)); } catch { /* not kept */ }
  return cache;
}
